import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_IBL_REG_003_POP_03 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridApiRefL = useRef<any>(null);
    const dblClickRowRef = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        dblClickRowRef.current
          ? [dblClickRowRef.current]
          : gridApiRefL.current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_TRA_IBL_REG_003_POP_03",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums1(rtn.grid.grid1);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_tra_ibl_reg_003_pop_03_01",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);

          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));
            gridApiRefL.current.selectAndFocusRow(0);
          }

          gridApiRefL.current.resetUpdate();
        } catch (error: any) {}
      };
      fetchdatasource();
    };

    const onRowDoubleClicked = (e: any) => {
      if (!e?.data) return;
      dblClickRowRef.current = e.data;
      modalRef?.current?.handleConfirm(true);
    };

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <div>
            <div style={{ height: "55vh", marginTop: "10px" }}>
              <SnGrid
                ref={gridApiRefL}
                columnConfig={columns1}
                rowData={dataSource1}
                etcProps={{ isEditable: false, rowSelection: "single" }}
                events={{ onRowDoubleClicked }}
                // ischeckboxSelection={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_TRA_IBL_REG_003_POP_03;
